import { DefaultButton, IComboBox, IComboBoxOption, Panel, PanelType, PrimaryButton, Stack } from '@fluentui/react';
import { Field } from 'components';
import { useSelector } from 'hooks';
import { map, sortBy } from 'lodash';
import { useEffect, useState, useMemo, FormEvent } from 'react';
import { useDispatch } from 'react-redux';
import { getTenants } from '../Tenants/state/tenants.actions';
import { updateFeatureFlagTenant } from './state/actions';
import { IFeatureFlagTenantModel } from './state/model';
import { openFeatureFlagTenantModal, selectedFeatureFlag, selectedFeatureFlagTenantListHistory } from './state/selector';
import { setFeatureFlagTenantModal } from './state/slice';
import useValidation, { getValidationError } from 'hooks/useValidation';
import { ISearchComboBoxOption } from 'components/Field/SearchComboField';

function AddTeanantModal() {
    const dispatch = useDispatch();
    const isPanelOpen = useSelector(openFeatureFlagTenantModal);
    const tenantList = useSelector(selectedFeatureFlagTenantListHistory);
    const selectFeatureFlag = useSelector(selectedFeatureFlag);

    const [selectedTenantIds, setTenantIds] = useState<string[]>([]);

    useEffect(() => {
        dispatch(getTenants());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        return () => {
            cleanupErrors();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPanelOpen]);

    const _onDismiss = () => {
        dispatch(setFeatureFlagTenantModal(false));
        setTenantIds([]);
    };

    const onSelectTenant = (_: FormEvent<IComboBox>, option?: IComboBoxOption) => {
        if (!option?.key) return;

        setTenantIds((currentTenantIds) => {
            if (currentTenantIds.includes(option.key as string)) {
                return currentTenantIds.filter((tenantId) => tenantId !== option.key);
            } else {
                return [...currentTenantIds, option.key as string];
            }
        });
    };

    const tenantOptions: ISearchComboBoxOption[] = useMemo(() => {
        return tenantList
            ? sortBy(
                  map(tenantList, (tenant) => ({
                      key: tenant.id,
                      text: `${tenant.displayName ?? tenant.name ?? ''} - ${tenant.id}`,
                  })) ?? [],
                  'text',
              )
            : [];
    }, [tenantList]);

    const onSave = () => {
        const model: IFeatureFlagTenantModel = {
            tenantIds: selectedTenantIds,
            featureFlag: {
                isActive: true,
                isDeleted: false,
            },
        };

        if (selectFeatureFlag) {
            dispatch(setFeatureFlagTenantModal(false));
            dispatch(
                updateFeatureFlagTenant({
                    featureFlagId: selectFeatureFlag.id,
                    model,
                }),
            );
        }
        setTenantIds([]);
    };

    const [errors, onSubmit, cleanupErrors] = useValidation(
        [
            {
                fieldName: 'tenantIds',
                validation: ['required'],
                value: selectedTenantIds,
            },
        ],
        onSave,
    );

    return (
        <Panel
            headerText={`Add Tenant`}
            isOpen={isPanelOpen}
            isFooterAtBottom
            type={PanelType.medium}
            onDismiss={_onDismiss}
            onRenderFooterContent={() => (
                <Stack tokens={{ childrenGap: 5 }} grow>
                    {/* <ValidationBar errors={errors} /> */}
                    <Stack horizontal tokens={{ childrenGap: 12 }}>
                        <PrimaryButton text={'Save'} onClick={onSubmit} />
                        <DefaultButton text="Cancel" onClick={_onDismiss} />
                    </Stack>
                </Stack>
            )}
        >
            <Stack styles={{ root: { padding: 10 } }} grow>
                <Field.SearchCombo
                    placeholder="(Select Tenant(s))"
                    label="Tenant(s)"
                    multiSelect
                    options={tenantOptions}
                    threshold={0.3}
                    onChange={onSelectTenant}
                    selectedKey={selectedTenantIds}
                    errorMessage={getValidationError(errors, 'tenantIds') ? 'Tenant(s) is required' : undefined}
                />
            </Stack>
        </Panel>
    );
}

export default AddTeanantModal;
